<template>
  <div>
    <div class="totals-container">
      <div class="totals-content">
        <CustomSkeleton v-if="isLoadingAllData" type="line" />
        <span v-if="!isLoadingAllData" class="totals-title">{{ totalVisitors }}</span>
        <span class="totals-subtitle">Visitantes</span>
      </div>

      <div class="totals-content">
        <CustomSkeleton v-if="isLoadingAllData" type="line" width="200px" />
        <span v-if="!isLoadingAllData" class="totals-title">R${{ totalSpend }}</span>
        <span class="totals-subtitle">Gasto Médio do Visitante</span>
      </div>
    </div>
    <div class="average-spend-chart-container">
      <CustomSkeleton v-if="isLoadingAllData" type="card" />
      <CustomChart
        v-if="!isLoadingAllData"
        :data-options="dataOptions"
        :legends="legends"
        :data-sets="processedDataSets"
        :has-time-frame="false"
        :has-filter="true"
        :chart-type="'line'"
        :chart-id="'average-spend-chart'"
        title="Gasto Médio do Visitante"
        :text="totalSpendText"
        :subtext="subtext"
        :style-chart="stylesChart"
        @filter-change="handleFilterChange"
      />
    </div>
  </div>
</template>

<script>
import CustomChart from '../Chart/CustomChart.vue'
import { Chart, registerables } from 'chart.js'
import CustomSkeleton from '@/Shared/CustomSkeleton'
Chart.register(...registerables)

export default {
  name: 'AverageVisitorSpend',
  components: {
    CustomChart,
    CustomSkeleton,
  },
  props: {
    transportQuestion: {
      type: Object,
      required: true,
    },
    consumeQuestion: {
      type: Object,
      required: true,
    },
    visitors: {
      type: Object,
      required: true,
    },
    isLoadingAllData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dataOptions: [
        { label: 'Transporte', value: 'transportQuestion' },
        { label: 'Compras', value: 'consumeQuestion' },
      ],
      legends: [
        { color: '#0E9BA4', text: 'Transporte' },
        { color: '#E135F0', text: 'Compras' },
      ],
      stylesChart: {
        width: '100%',
        height: '419px',
      },
      filteredModes: null,
      totalSpend: null,
      totalVisitors: this.visitors ? this.visitors.visitors : 0,
    }
  },
  computed: {
    processedDataSets() {
      if (!this.transportQuestion || !this.consumeQuestion) {
        return []
      }
      return [
        {
          label: 'Transporte',
          value: 'transportQuestion',
          toolTipLegend: 'R$',
          color: '#0E9BA4',
          barThickness: 10,
          answers: this.processAnswers(this.transportQuestion.answers),
        },
        {
          label: 'Compras',
          value: 'consumeQuestion',
          toolTipLegend: 'R$',
          color: '#E135F0',
          barThickness: 10,
          answers: this.processAnswers(this.consumeQuestion.answers),
        },
      ]
    },
    totalSpendText() {
      return `R$${this.calculateTotalSpend()}`
    },
    subtext() {
      return this.filteredModes
        ? 'Gasto médio filtrado por modo'
        : 'É o gasto médio total do visitante'
    },
  },
  watch: {
    isLoadingAllData: {
      handler(n, o) {
        if (!n) {
          this.totalSpend = this.calculateTotalSpend()
        }
      },
      immediate: true,
    },
    visitors: {
      handler(newVal) {
        if (newVal) {
          this.totalVisitors = newVal.visitors
        }
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.transportQuestion)
    console.log(this.consumeQuestion)
    console.log(this.visitors)
    console.log(this.isLoadingAllData)
  },
  methods: {
    processAnswers(answers) {
      if (!answers) return []
      return answers.map((answer) => ({
        answer_date: answer.answer_date,
        answer_text: this.getAnswerValue(answer.answer_text),
      }))
    },
    getAnswerValue(answerText) {
      switch (answerText) {
        case '1000':
          return 500
        case '2000':
          return 1500
        case '3000':
          return 2500
        case '3001':
          return 3500
        case '500':
          return 250
        case '1500':
          return 1250
        case '1501':
          return 1600
        default:
          return 0
      }
    },
    calculateTotalSpend() {
      const totalData =
        this.filteredModes && this.filteredModes.length > 0
          ? this.filteredModes.flatMap((mode) => this.processAnswers(this[mode.value].answers))
          : [
              ...this.processAnswers(this.transportQuestion.answers),
              ...this.processAnswers(this.consumeQuestion.answers),
            ]
      if (totalData.length === 0) return '0.00'
      const total = totalData.reduce((acc, curr) => acc + curr.answer_text, 0)
      return (total / totalData.length).toFixed(2)
    },
    handleFilterChange(selectedModes) {
      this.filteredModes = selectedModes
    },
  },
}
</script>

<style src="./styles.css"></style>
